import styled from 'vue-styled-components';

const WrapperProps = {
    transform: Array,
    isShowCustomPicker: Boolean
}
const DropdownWrapper = styled('div', WrapperProps)`
    padding: 0;
    .setting-box {
        width: ${({isShowCustomPicker}) => isShowCustomPicker ? '190' : '240'}px;
        overflow: hidden;
        padding: ${({isShowCustomPicker}) => isShowCustomPicker ? '16px' : '12px 24px'}
        border: unset;
        box-shadow: 0px 16px 48px rgba(0, 0, 0, 0.176);
        ${({transform}) => transform.lenght > 0 ? `transform: translate3d(${transform[0]}px, 10px, 0px) !important;` : ''}
    }
    .menu-picker{
        display: flex;
        flex-direction: column;
    }
    .title {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0;
        z-index: 10;
        background-color: white;
        border-bottom: solid 1px #DEE3E6;
    }
    .close-btn {
        font-size: 20px;
        color: rgba(0, 0, 0, 0.5);
        &:hover{
            cursor: pointer;
        }
    }
    .palette-container {
        display: grid;
        justify-items: center;
        grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
        line-height: 0;
        overflow: auto;
        /* overflow: hidden;
        text-overflow: ellipsis; */
        min-height: 40px;
        max-height: 96px;
        /* margin: 5px 15px 8px 15px;
         padding-left: 4px; */
         scrollbar-width: none;
        -ms-overflow-style: none;
    }
    .picker-tool{
        display: flex;
        justify-content: center;
        height: 100%;
    }
`

const PaletteColor = styled.div`
    width: 24px;
    height: 24px;
    border-radius: 50%;
    /* border: solid 1px #FFFFFF; */
    transition: all 0.2s ease;
    svg {
        display: none;
    }
    &:hover, &.active {
        cursor: pointer;
        /* border-color: black; */
        transform: scale(1.1);
        color: blue;
      
    }
    &.active {
        border: solid 2px #FFFFFF !important;
        box-shadow: 0 0 0 1px #a3a3a3;
        /* svg {
            display: block;
        } */
        /* outline: 3px solid #000000; */
        /* &::after {
            content: '';
            border-radius: 50%;
            outline: 2px solid var(--primary);
            outline: 3px solid #000000;
            box-shadow: 0 0 5px 2px #000000;
            width:100%;
            height: 100%;
            position:absolute;
            top: 0;
        } */
    }
`
const AddColor = styled.div`
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: solid 1px #ffffff;
    position: relative;
    cursor: pointer;
    border-color: black;
    margin: 0;
    transition: all 0.2s ease;
    &:hover{
        transform: scale(1.1);
    }
`

const PaletteTemplateColor = styled.div`
    height: 24px;
    width: 32px;
   
    transition: transform 0.2s ease;
    svg {
        display: none;
    }
    &:hover, &.active {
        position: relative;
        cursor: pointer;
        /* border-color: black; */
        /* transform: scale(1.1); */
        &::after {
            content: '';
            /* outline: 2px solid var(--primary); */
            outline: 2px solid #FFFFFF;
            box-shadow: 0 0 5px 2px #000000;
            position:absolute;
            width:100%;
            height: 100%;
            top: 0;
        }
    }
    /* &.active {
        svg {
            display: block;
        }
    } */
`
const SliderProps = {
    color: String
}
const Slider = styled('input', SliderProps)`

  -webkit-appearance: none;
  width: 100%;
  height: 8px;
  border-radius: 15px;
  background: linear-gradient(90deg, transparent 0%, ${({ color }) => color} 100%);
  outline: none;
  -webkit-transition: .2s;
  transition: opacity .2s;

&::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 15px;
  height: 15px;
  margin-top: -2px;
  background: var(--primary);
  cursor: pointer;
  border: 3px solid white;
  border-radius: 50%;
  box-shadow: 0 1px 3px 0 rgb(52 94 151 / 60%);
}

&::-moz-range-thumb {
    width: 15px;
    height: 15px;
    background: var(--primary);
    cursor: pointer;
    border: 3px solid white;
    border-radius: 50%;
    box-shadow: 0 1px 3px 0 rgb(52 94 151 / 60%);
}
`
const SliderWrapper = styled.div`
width: auto;
border: 1px solid #d5d5d5;
height: 10px;
border-radius: 15px;
background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAIAAADZF8uwAAAAGUlEQVQYV2M4gwH+YwCGIasIUwhT25BVBADtzYNYrHvv4gAAAABJRU5ErkJggg==);


`
const DisplayWrapper = styled.div`
border: 1px solid #CED4DA;
background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAIAAADZF8uwAAAAGUlEQVQYV2M4gwH+YwCGIasIUwhT25BVBADtzYNYrHvv4gAAAABJRU5ErkJggg==);
`

const AlphaWrapper = styled.div`
line-height: 0;
position: relative;

.input-alpha::after {
    font-family: 'Sarabun';
    font-size: 12px;
    color: #53585D;
    right: 8px !important;
    top: 12px !important;
}
/* &::after {
    content: '%';
    font-family: 'Sarabun';
    font-size: 12px;
    color: #53585D;
    position: absolute;
    width: 8px;
    height: 8px;
    z-index: 10;
    right: 8px;
    top: 55%; */
}
`

const InputNumber = styled.input`
width: 48px;
height: 32px;
border: unset;
outline: unset;
text-align: right;
font-family: 'Sarabun';
font-size: 14px;
color: #53585D;
margin-left: 5px;
padding-right: 16px;
border-radius: 4px;
border: solid 1px #CED4DA;
/* &::after {
    content: '%';
    position: absolute;
    width: 10px;
    height: 10px;
    z-index: 10;
    right: 0;
    top: 0;
} */

&:focus, &:active, &:focus-visible {
    color: #373E44;
    background-color: #FFFFFF;
    outline: 0;
    border-color: #24BEE2;
    box-shadow: 0px 0px 6px 2px rgb(36 190 226 / 25%), inset 0px 1px 2px rgb(0 0 0 / 10%);
    -webkit-box-shadow: 0px 0px 6px 2px rgb(36 190 226 / 25%), inset 0px 1px 2px rgb(0 0 0 / 10%);

}
/* Chrome, Safari, Edge, Opera */

&::-webkit-outer-spin-button,
&::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
&[type=number] {
  -moz-appearance: textfield;
}
`
export {
    DropdownWrapper,
    PaletteColor,
    PaletteTemplateColor,
    Slider,
    SliderWrapper,
    InputNumber,
    AlphaWrapper,
    DisplayWrapper,
    AddColor
}